import type { SearchVehicle } from '../types'

export const stockNumber = ({ stockNumber: _stockNumber }: SearchVehicle): string =>
    _stockNumber && parseInt(_stockNumber, 10) > 0 ? _stockNumber || '' : ''
